export default __webpack_public_path__ + "10faf28b129b8fc50cc7fe0a7bce0094.png";